var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2500,
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 512c0 283 229 512 512 512s512-229 512-512S795 0 512 0 0 229 0 512z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M747 277c-102-101-263-105-361-8-175 176-119 488-119 488s313 56 488-119c97-98 94-260-8-361zM621 503l-50 103-50-103-103-50 103-50 50-103 50 103 103 50z",
    fill: "#0096FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapBox);
export default __webpack_public_path__ + "static/media/MapBox.534590db06fd93c4115ea4dcd4fbb335.svg";
export { ForwardRef as ReactComponent };